<template>
  <v-row v-if="!isLoggedIn" align="center" justify="center">
    <!--<v-col class='col-12' align="center" justify="center"><v-alert
      border="top"
      colored-border
      type="info"
      elevation="2"
      max-width="600"
    >
      Для доступа в данный раздел необходимо зарегистрироваться
    </v-alert></v-col>-->
    <auth>
    </auth>
  </v-row>
  <div v-else style="width: 100%;">
    <v-container class="mt-n8" v-if="hasOperatorRole(roles)">
      <v-row>
        <v-col v-for="item in allowedTicketTypes" :key="item.id" cols="12">
          <v-card @click="$router.push({ path: `tickets/tickets_by_type/${item.id}`})">
            <div class="d-flex flex-no-wrap justify-start">
              <v-avatar size="80" tile>
                <v-icon x-large v-html="userTicketTypes[item.id].icon" color="primary" />
              </v-avatar>
              <div>
                <v-card-title class="subtitle-2" v-text="item.name.replace('Заявка', 'Заявки')"></v-card-title>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else class="mt-n8">
      <v-row>
        <v-col cols="12">
          <v-card @click.prevent="$router.push({ path: 'tickets/my_tickets' })">
            <div class="d-flex flex-no-wrap justify-start">
              <v-avatar size="80" tile>
                <v-icon x-large v-html="'person'" color="primary" />
              </v-avatar>
              <div>
                <v-card-title class="subtitle-2">Мои заявки</v-card-title>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card @click.prevent="$router.push({ path: 'tickets/new_question' })">
            <div class="d-flex flex-no-wrap justify-start">
              <v-avatar size="80" tile>
                <v-icon x-large v-html="'mdi-account-question'" color="primary" />
              </v-avatar>
              <div>
                <v-card-title class="subtitle-2">Обращение</v-card-title>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col v-for="item in userTicketTypes" :key="item.id" cols="12" v-if="item.id != 5 & item.id != 6 & item.id != 4">
          <v-card>
            <div class="d-flex flex-no-wrap justify-start">
              <v-avatar size="80" tile>
                <v-icon x-large v-html="item.icon" color="primary" />
              </v-avatar>
              <div>
                <v-card-title class="subtitle-2" v-text="item.name"></v-card-title>
                <v-card-subtitle>
                  <a class="card-item" @click.prevent="$router.push({ path: `tickets/create/${item.id}`, query: { individual: 'true' } })">Для физических лиц</a>
                  <!-- <a disabled class="card-item" @click.prevent="$router.push({ path: `tickets/create/${item.id}`, query: { individual: 'false' } })">Для юридических лиц</a> -->
                  <a class="card-item" style="text-decoration: line-through">Для юридических лиц</a>
                </v-card-subtitle>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col>
          <v-card link href="https://gosuslugi.primorsky.ru/pgu/categories/info.htm?id=19879@egClassification">
            <div class="d-flex flex-no-wrap justify-start">
              <v-avatar size="80" tile>
                <v-icon x-large v-html="'mdi-pipe-disconnected'" color="primary" />
              </v-avatar>
              <div>
                <v-card-title class="subtitle-2">Подать заявку на подключение (для юридических лиц)</v-card-title>
                <v-card-subtitle>
                  <p class="card-item">С июня 2024 заявки на подключения от юридических лиц принимаются через портал Правительства Приморского Края</p>
                </v-card-subtitle>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card @click.prevent="$router.push({ path: 'tickets/new_corruption_question' })">
            <div class="d-flex flex-no-wrap justify-start">
              <v-avatar size="80" tile>
                <v-icon x-large v-html="'mdi-comment-text'" color="primary" />
              </v-avatar>
              <div>
                <v-card-title class="subtitle-2">Обращение по поводу коррупционного правонарушения</v-card-title>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Requests',

  components: {
    auth: () => import(
      '@/views/LoginView'
    )
  },


  data: () => ({
    roles: [],
    operatorTicketTypes: [],
    operatorRoleName: 'operator',
    //icons: ['house', 'home_work', 'house']
  }),

  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isAuthenticated',
      userLogin: 'user/userLogin',
      userTicketTypes: 'common/ticketTypes'
    }),
    allowedTicketTypes: function() {
      let rolesArr = this.roles
      let self = this
      return this.operatorTicketTypes.filter(function(value) {
        let isMatch = false
        value.roles.forEach(function(r) {
          isMatch = isMatch || rolesArr.indexOf(r) != -1
        })
        if (!(value.id in self.userTicketTypes)) return false
        return isMatch
      })
    }
  },

  watch: {
    userLogin: function(newLogin, oldLogin) {
      this.getUserRoles()
    }
  },

  mounted: function() {
    if (this.isLoggedIn) {
      this.getTicketTypes()
      this.getUserRoles()
    }
  },

  methods: {
    getUserRoles: async function() {
      try {
        const resp = await this.$api.Account.getUserRoles(this.userLogin)
        this.roles = JSON.parse(JSON.stringify(resp.data))
      } catch (e) {
        const err = e
        let error = 'Не удалось получить информацию о пользователе. Попробуйте повторить запрос позднее'
        if (e.response.status == 401 || e.response.status == 403) {
          await this.$store.dispatch('user/authLogOut')
          location.href = location.href
        }
        await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
        console.error(e)
      }
    },
    getTicketTypes: async function() {
      try {
        const resp = await this.$api.Account.getTicketTypes()
        this.operatorTicketTypes = resp.data
      } catch (e) {
        const err = e
        if (e.response.status == 401 || e.response.status == 403) {
          await this.$store.dispatch('user/authLogOut')
          location.href = location.href
        }
        let error = 'Не удалось получить информацию о заявках. Попробуйте повторить запрос позднее'
        await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
        console.error(e)
      }
    },
    hasOperatorRole: function(roles) {
      //console.log(roles)
      for (var id = 0; id < roles.length; id++) {
        if (roles[id].includes(this.operatorRoleName)) return true
      }
      return false
    }
  }

}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.card-item {
  text-decoration: none;
  color: black !important;
  opacity: 0.6;
}

.card-item:hover {
  color: #2196f3 !important;
  cursor: pointer;
  opacity: 1;
}

.card-item:after {
  content: " | ";
}

.card-item:hover:after {
  color: black;
  opacity: 0.6;
}

.card-item:last-child:after {
  content: '';
}

@media (min-width: 720px) {
  .sub-item {
    display: none;
  }
}
</style>